<template>
  <div>
    <add-representative-request-applicant
      :form-model="formModel"
      :is-new-mode="isNewMode"
      :is-view-mode="isViewMode"
      :is-edit-mode="isEditMode"
    ></add-representative-request-applicant>
  </div>
</template>

<script>
import { mode } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule'); // todo REMOVE
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapBankruptcyActions } = createNamespacedHelpers('BankruptcyModule');
import AddRepresentativeRequestApplicant from '@/modules/bankruptcy/components/sub-requests/add-representative-request-applicant';

import { subRequestType } from '@/modules/bankruptcy/helpers/enum';

export default {
  name: 'BankruptcyAddRepresentative',
  inject: ['$validator'],
  components: { AddRepresentativeRequestApplicant },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { subRequestType };
  },
  computed: {
    ...mapLUTState([]),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.subRequestObjectKey == undefined || this.$route.params.subRequestObjectKey == null;
    },
  },
  watch: {},
  mounted() {
    this.loadData();
    this.formModel.subRequestTypeId = subRequestType.AddRepresentative;
  },
  created() {
  },
  methods: {
    ...mapBankruptcyActions([]),
    loadData() {
    },
    ...mapActions([
    ]),

  },
};
</script>

<style lang="scss" scoped>
</style>